import _ from 'underscore';
import {completions as autocompletions} from '@netx/core-app/properties/autocomplete';
import AttributesCollection from '@netx/core-asset/collections/attributes';
import AttributeModel from '@netx/core-asset/models/attribute';
import {dispatcher} from '@netx/core-next/instance/dispatcher';
import {useAttributesStore} from '../store/attributesStore';

export const attributes = new AttributesCollection([]);
export const attributeTemplates = attributes;

attributes.listenTo(
	dispatcher,
	'system:attribute:edit:success',
	(model: any, isNew: boolean) => {
		if (!isNew) return;
		// Add the model attributes so that we get the proper attribute model type
		// when creating a new attribute the model is just the generic base model
		attributes.add(model.attributes);
		attributes.sort();
	},
);

// Update autocompletions
const attributeHistoryCompletion = autocompletions.attributeHistory;
attributes.on(
	'add remove sync',
	_.debounce(() => {
		// @ts-ignore
		attributeHistoryCompletion.data = attributes
			.filterByHistory()
			.map((attr: AttributeModel) => ({
				label: attr.getLabel(),
				value: attr.id,
			}));
	}, 50),
);

// Keeping clip and asset attributes together in the same call with wholly different needs was
// kinf of a mistake
export const assetAttributes = attributes.filterByObjectType('asset');
export const clipAttributes = attributes.filterByObjectType('clip');

// Update our sub attribute collections
const attributesChanged = _.debounce(() => {
	assetAttributes.set(attributes.filterByObjectType('asset').models, {
		merge: true,
	});
	clipAttributes.set(attributes.filterByObjectType('clip').models, {
		merge: true,
	});
	dispatcher.trigger('asset:attributes:updated', attributes);
}, 25);

attributes
	.on('add remove', attributesChanged)
	.on('change', (model) => {
		!_.isEmpty(model.changed) && attributesChanged();
	})
	.on('sync', (collection) => {
		collection === attributes && attributesChanged();
	});

export const getAttribute = (id?: number, name?: string) => {
	if (id != null) return attributes.get(parseInt(id.toString()));
	if (name != null) return attributes.findWhere({name: name});
};

export const getAttributesByObjectType = (type: 'asset' | 'clip') => {
	return attributes.filterByObjectType(type);
};

export const getAttributeId = (name: string) => {
	return getAttribute(undefined, name)?.id;
};

attributes.on('sync change reset add remove request:read', () => {
	useAttributesStore.getState().update(
		attributes.map((m) => ({...m.attributes})),
		!attributes.syncedOnce || attributes.syncing,
	);
});

export default attributes;

import {setGlobal} from '@netx/core-next/utils/setGlobal';
// circular dependency:
// attribute model (related to some metadata map stuff)
// attribute collection (related to some metadata map stuff)
// if (process.env.NODE_ENV !== 'production') {
setGlobal({attributes, assetAttributes, clipAttributes});
//}
